import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, UsersIcon, CalendarIcon, ArrowRightIcon } from 'lucide-react';
interface ImpactCardProps {
  change: {
    id: number;
    title: string;
    payer: string;
    changeType: string;
    changeDate: string;
    impactedLives: string;
    changeDescription: string;
    affectedProducts: string[];
    recommendations: string[];
  };
}
const ImpactCard: React.FC<ImpactCardProps> = ({
  change
}) => {
  const [expanded, setExpanded] = useState(false);
  return <div className="overflow-hidden bg-white rounded-lg shadow transition-all hover:shadow-md" data-id="element-31">
      <div className={`h-2 w-full ${change.changeType === 'negative' ? 'bg-red-500' : change.changeType === 'positive' ? 'bg-green-500' : 'bg-amber-500'}`} data-id="element-32"></div>
      <div className="p-5" data-id="element-33">
        <div className="flex items-start justify-between mb-3" data-id="element-34">
          <span className={`px-2 py-1 text-xs font-medium rounded-full ${change.changeType === 'negative' ? 'bg-red-100 text-red-800' : change.changeType === 'positive' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-35">
            {change.changeType.charAt(0).toUpperCase() + change.changeType.slice(1)}{' '}
            Change
          </span>
          <span className="flex items-center text-xs text-gray-500" data-id="element-36">
            <CalendarIcon className="w-3 h-3 mr-1" data-id="element-37" />
            {change.changeDate}
          </span>
        </div>
        <h3 className="mb-1 text-lg font-medium text-gray-900 line-clamp-2" data-id="element-38">
          {change.title}
        </h3>
        <p className="mb-3 text-sm text-gray-600" data-id="element-39">{change.payer}</p>
        <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-40">
          <UsersIcon className="w-4 h-4 mr-1" data-id="element-41" />
          <span data-id="element-42">
            <strong data-id="element-43">{change.impactedLives}</strong> lives impacted
          </span>
        </div>
        <p className="text-sm text-gray-700 mb-4" data-id="element-44">{change.changeDescription}</p>
        {expanded && <>
            <div className="mt-4" data-id="element-45">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-46">
                Affected Products
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-47">
                {change.affectedProducts.map((product, index) => <span key={index} className="px-2 py-1 text-xs bg-gray-100 text-gray-800 rounded" data-id="element-48">
                    {product}
                  </span>)}
              </div>
            </div>
            <div className="mt-4" data-id="element-49">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-50">
                Recommended Actions
              </h4>
              <ul className="text-sm text-gray-700 space-y-1 pl-5 list-disc" data-id="element-51">
                {change.recommendations.map((rec, index) => <li key={index} data-id="element-52">{rec}</li>)}
              </ul>
            </div>
          </>}
        <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-53">
          <button className="text-sm font-medium text-gray-600 hover:text-gray-800 flex items-center" onClick={() => setExpanded(!expanded)} data-id="element-54">
            {expanded ? <>
                Show Less <ChevronUpIcon className="w-4 h-4 ml-1" data-id="element-55" />
              </> : <>
                Show More <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-56" />
              </>}
          </button>
          <button className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center" data-id="element-57">
            View Analysis <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-58" />
          </button>
        </div>
      </div>
    </div>;
};
export default ImpactCard;